import getConfig from "../config/index";

export default {
  // 获取用户信息
  getUserInfo: `${getConfig().userInfoURL}/GetUserInfo`,
  // 查询活动信息
  activityInfo: "/oper/activity/get",
  // 获取活动首页信息
  getHomePage: "/api/mgc/club/homepage",
  // 获取芒果卡身份
  getIsHit: "/api/mgc/act/getMgcInfo",
  // 微信h5,分享签名接口
  getSignWxSdk:
    "https://weixinapi.yys.mgtv.com/WeixinSDK?Action=getsign&type=DX",
  // 活动信息下发
  getSuperInfo: `${getConfig().actUrl}/api/mgcact/super/show/info`,
  // 查询中奖列表
  getSuperList: `${getConfig().actUrl}/api/mgcact/super/show/list`,
  // 领取新用户礼包接口
  getClaim: `${getConfig().actUrl}/api/mgcact/super/show/claim`,
  // 参加活动接口
  setJoinSuper: `${getConfig().actUrl}/api/mgcact/super/show/submit`,
  // 认证接口
  setIdentity: `${getConfig().actUrl}/api/mgcact/super/show/identity`,
  // 报名接口
  setSignup: `${getConfig().actUrl}/api/mgcact/super/show/signup`,
  // 订阅通知
  setSubscription: `${getConfig().actUrl}/api/mgcact/super/show/subscription`,
  /**查询帖子列表*/
  getPostListByActivity: `${
    getConfig().clubUrl
  }/online/activity/dynamicListByActivity`,
  /**查询帖子列表*/
  getActIds: `${getConfig().actUrl}/api/mgcact/super/show/get/activityIds`,

  // 查询榜单列表
  getRankList: `${getConfig().actUrl}/api/mgcact/super/show/rankList`,
};
